import './Cart.css';
import { FaShoppingCart, FaTrashAlt } from 'react-icons/fa';
import { useCallback, useRef } from 'react';
import { useOnClickOutside } from 'hooks';
import { useDispatch, useSelector } from 'react-redux';
import {
    setCartOpenState,
    removeCartItem,
    setSmallCartOpenState,
} from './cartSlice';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import axios from 'axios';
import { apiConfig } from 'config';

const Cart = ({ isMobile = false }) => {
    const dispatch = useDispatch();
    const pickerRef = useRef(null);
    // const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);
    const isOpen = useSelector((state) => state.cart?.openSmallCart);
    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);
    const items = useSelector((state) => state.cart?.cartItems);
    const currency = useSelector((state) => state.user?.currency);
    const cartItems = useSelector((state) => state.cart?.cartItems);

    const onClick = useCallback(() => {
        dispatch(setSmallCartOpenState(!isOpen));
    }, [isOpen]);
    const handleClickOutside = () => {
        dispatch(setSmallCartOpenState(false));
    };

    const removeItem = async (rateID, roomTypeID) => {
        const cartItem = cartItems.find(
            (item) => item.rateID === rateID && item.roomTypeID === roomTypeID
        );
        if ((await removeFromCartBack(cartItem)) === 'ok') {
            dispatch(setSmallCartOpenState(true));
            dispatch(removeCartItem(rateID));
        }
    };

    const removeFromCartBack = async (cartItem) => {
        try {
            const response = await axios.post(apiConfig?.removeFromCartBack, {
                ...cartItem,
            });

            if (response?.data.split(',')[0].toLowerCase() === 'ok') {
                return 'ok';
            } else {
                toast.error(Lang?.somethingWentWrong, {
                    autoClose: true,
                    theme: 'colored',
                    PlacementType: 'top-left',
                });
                return 'error';
            }
        } catch (error) {
            toast.error(Lang?.networkError, {
                autoClose: true,
                theme: 'colored',
            });
            return 'error';
        }
    };

    const openCartDrawer = (state) => {
        dispatch(setCartOpenState(state));
        dispatch(setSmallCartOpenState(false));
    };

    useOnClickOutside(pickerRef, handleClickOutside);
    return (
        <div id="headerCart" ref={pickerRef}>
            <div
                id="MainCartIcon"
                className="mini-cart hide-small-viewport hide-medium-viewport has-items active"
            >
                {items?.length > 0 && (
                    <strong
                        className={`js-cart-items-count ${
                            isMobile ? 'mobile-cart' : ''
                        }`}
                    >
                        {items?.length}
                    </strong>
                )}
                <a
                    className={`go-to-cart ${isMobile ? 'mobile-cart' : ''}`}
                    id="ActualCartIcon"
                    onClick={onClick}
                >
                    <FaShoppingCart size={!isMobile ? 22 : 20} />
                </a>
            </div>

            {isOpen && (
                <div id="CartDiv">
                    <div
                        className={`notification remote mini_cart_popup center bottom ${
                            isMobile ? 'mobile-cart' : ''
                        }`}
                    >
                        <div className="inner cf">
                            <div
                                className={`mini-cart-panel js-mini-cart-panel ${
                                    isMobile ? 'mobile-cart' : ''
                                }`}
                            >
                                <strong className="cart-quantity">
                                    {Lang?.cartItems} (
                                    <span id="yourCartCount">
                                        {items?.length}
                                    </span>
                                    )
                                </strong>
                                <ul className="order-list">
                                    {items?.map((item, index) => {
                                        const totalPrice = item?.extras?.reduce(
                                            (total, extra) => {
                                                const extraPrice =
                                                    Number(extra.price) || 0;
                                                const extraQuantity =
                                                    Number(extra.quantity) || 0;
                                                return (
                                                    total +
                                                    extraPrice * extraQuantity
                                                );
                                            },
                                            0
                                        );
                                        return (
                                            <li key={index}>
                                                <div className="cell">
                                                    <a className="suborder-item-details">
                                                        {item?.quantity} x{' '}
                                                        {item?.roomName}
                                                    </a>
                                                    <a className="suborder-item-details">
                                                        {item?.rateName}
                                                    </a>
                                                    <p className="quantity">
                                                        {Lang?.price}:
                                                        <strong>
                                                            {new Intl.NumberFormat(
                                                                'en-US',
                                                                {
                                                                    style: 'currency',
                                                                    currency:
                                                                        currency,
                                                                }
                                                            ).format(
                                                                Number(
                                                                    item?.price +
                                                                        totalPrice
                                                                )
                                                            )}{' '}
                                                        </strong>
                                                    </p>
                                                </div>
                                                <div className="cell">
                                                    <div
                                                        onClick={() =>
                                                            removeItem(
                                                                item?.rateID,
                                                                item?.roomTypeID
                                                            )
                                                        }
                                                    >
                                                        <FaTrashAlt />
                                                    </div>
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>

                                <div className="bottom-container">
                                    <a
                                        className={`view-all btn-green next-step-btn  ${
                                            !items?.length && 'ab-disabled-btn'
                                        }`}
                                        onClick={() => openCartDrawer(true)}
                                    >
                                        {Lang?.goToCart}
                                    </a>
                                </div>
                                <div id="cartTopArrow"></div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

Cart.propTypes = {
    isMobile: PropTypes.bool,
};

export default Cart;
